import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { InventoryExport } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class InventoryExportService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  public async getInventoryExport(id, schema = { id: null }): Promise<InventoryExport> {
    return new InventoryExport(await this.core.services.inventoryExport.getById(id, schema))
  }

  async getInventoryExports(
    // todo
    parameters: any = {
      page: 1,
      sort: 'id',
      direction: 'asc',
    },
    schema: any = { id: null }
  ): Promise<{
    items: InventoryExport[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.inventoryExport.getList(parameters, schema)
  }

  // createCheckout(checkout: Partial<Checkout>, schema: Checkout): Promise<Checkout> {
  //     return this.core.services.checkout.createWithTanstack(checkout, schema)
  // }

  async updateInventoryExport(
    inventoryExport: Partial<InventoryExport>,
    schema = { id: null }
  ): Promise<InventoryExport> {
    return await this.core.services.inventoryExport.update(inventoryExport, schema)
  }

  async refreshExportInventory(
    inventoryExport: Partial<InventoryExport>,
    schema: any = { id: null }
  ): Promise<InventoryExport> {
    return await this.core.services.inventoryExport.refreshExportInventory(inventoryExport, schema)
  }
}
